export default ({ COLORS }) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px'
  },
  active: {
    '& $iconHolder': {
      background: COLORS.BLUE.NORMAL,
      '& > svg': {
        color: '#fff'
      }
    }
  },
  iconHolder: {
    borderRadius: '5px',
    padding: '5px',
    width: '30px',
    height: '30px',
    background: '#ececec',
    marginRight: '10px',
    '& > svg': {
      width: '100%',
      height: '100%',
      color: COLORS.BLUE.NORMAL
    }
  },
  label: {
    transition: 'opacity 0.3s',
    opacity: '0'
  },
  showLabel: {
    '& $label': {
      opacity: '1'
    }
  },
  disabled: {
    '& $iconHolder': {
      '& > svg': {
        color: '#ccc'
      }
    }
  }
})
